module.exports = __webpack_public_path__ + "img/126.5dd78e5c.jpg";